<template></template>
<script>
export default {
  props: {
    type: {
      type: String,
      required: false,
      default: 'success'
    }
  },
  mounted () {
    this.$toasted.show(this.$slots.default[0].text, { type: this.type })
  }
}
</script>
